import { modelFamiliesModel } from './model-families-model'
import { z } from 'my-zod'

export const modelFamilySystemView = modelFamiliesModel.omit({ serverLastModifiedDate: true })

export type modelFamilySystemView = z.infer<typeof modelFamilySystemView>
